import React from 'react';
interface BatIconProps {
  className?: string;
}
export function BatIcon({
  className
}: BatIconProps) {
  return <svg viewBox="0 0 64 40" className={className} aria-hidden="true" data-id="element-18" data-mp="pwbihpc588li">
      <path d="M32 12c-2.2 0-3.6 1.4-4.2 3.2-2.6-4.4-8.4-7-14.8-6.4 2.4 2 3.2 4.6 2.6 7.2-3-1.6-7-1.8-10.6.2 4.6 1.6 7.6 5.4 8.2 10 3-2.2 7.2-2.4 10.2-.4 1.2-3 4.4-4.8 8.6-4.8s7.4 1.8 8.6 4.8c3-2 7.2-1.8 10.2.4.6-4.6 3.6-8.4 8.2-10-3.6-2-7.6-1.8-10.6-.2-.6-2.6.2-5.2 2.6-7.2-6.4-.6-12.2 2-14.8 6.4C35.6 13.4 34.2 12 32 12Z" fill="#1A1412" data-id="element-19" data-mp="14jwops4benxn" />
      <path d="M29.4 11.4 30.4 8l1.6 3.2L33.6 8l1 3.4" fill="#1A1412" data-id="element-20" data-mp="18num9ydzrqol" />
      <circle cx="29.8" cy="16.6" r="1.3" fill="#FF9A4D" data-id="element-21" data-mp="1nhpr8tb10vui" />
      <circle cx="34.2" cy="16.6" r="1.3" fill="#FF9A4D" data-id="element-22" data-mp="1ik7fkv5mk2it" />
    </svg>;
}